// extracted by mini-css-extract-plugin
export default {"wrapper":"Ep-z","response":"Fp-z","error":"Gp-z","disabled":"Hp-z","buttons":"Ip-z","feedbackQuestionSection":"Jp-z","yesNoWrapper":"Kp-z"};